import { render, staticRenderFns } from "./ImageThumb.vue?vue&type=template&id=235a0dd2&scoped=true&"
import script from "./ImageThumb.vue?vue&type=script&lang=js&"
export * from "./ImageThumb.vue?vue&type=script&lang=js&"
import style0 from "./ImageThumb.scss?vue&type=style&index=0&id=235a0dd2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235a0dd2",
  null
  
)

export default component.exports